/**
 * Turns a kebab-case slug into Title Case words (e.g. `south-end` → `South End`).
 * Shared by venue/neighborhood surfaces when the API returns only a slug.
 */
export function titleCaseKebabSlug(slug: string): string {
  return slug
    .split('-')
    .filter((part) => part.length > 0)
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(' ');
}
